import { Card, Center, Flex, Text } from "@mantine/core";
import { IStatbox } from "@mctypes/frontend.types";
import React from "react";
import CountUp from "react-countup";

export const StatsBox: React.FC<{ stat: IStatbox }> = ({ stat }) => (
  <Card
    withBorder
    radius="md"
    shadow="xs"
    style={{ width: "100%", minWidth: "120px", height: "150px" }}
    p="md"
  >
    <Center h="100%">
      <Flex direction="column" align="center" justify="center" gap="xs">
        <Flex align="center" style={{ fontSize: "40px", fontWeight: 300, lineHeight: 1.2 }}>
        {stat.icon && <i style={{ fontSize: "34px" }} className={`mr-2 fa  ${stat.icon} mt-2 ${stat.classColor}`} />}
        <CountUp duration={3} end={stat?.value ?? 0} />
        </Flex>
        <Text c="dimmed" ta="center" fw={700}>
          {stat.text}
        </Text>
      </Flex>
    </Center>
  </Card>
);
